export const getPipeElevationOffset = (diameter: number, thickness: number, elevType?: string, pipeNetType?: string): number => {
    const radius = 0.5 * diameter;
    let offset = 0;

    if (elevType) {
        if ('laki' === elevType || 'crown level' === elevType) {
            offset = -(radius + thickness);
        } else if ('invert level' === elevType) {
            offset = radius;
        }
    } else if (pipeNetType === 'water') {
        offset = -(radius + thickness);
    }

    if (isNaN(offset)) {
        return 0;
    }

    return offset;
};
